
import router from '../router'

export default {
	timeContrast(time) {
		// let year35 = new Date() 31536000000 * 35 // 35年
		let time1 = 567964800000 // 1988年1月1日
		let result = time1 <= time ? true : false
		return result
	},

	timeContrast2(regTime) {
		/** 
			时间条件判断(仅限昆山)
			1、注册时间2021年7月1日前，一律不符合参赛条件
			2、注册时间2021年7月1日-2022年10月23日，须年龄符合35周岁以下，进入下一步信息提交后，再判断；
			3、注册2022年10月23日后的，符合参赛条件
		*/
		if (!regTime) {
			return true
		}
		let result = false
		let time1 = 1625068800000 // 2021年7月1日
		let time2 = 1666454400000 // 2022年10月23日
		if (regTime < time1) {
			result = false
		} else if (regTime >= time1 && regTime <= time2) {
			result = true
		} else if (regTime > time2) {
			result = true
		}
		return result
	},

	timeContrast3(regTime, birthday) {
		/** 
			时间条件判断
		注册时间2021年7月1日-2022年10月23日，须年龄符合35周岁，进入下一步信息提交后，再判断；
		*/
		if (!regTime) {
			return true
		}
		let result = true
		let nowTime = new Date()
		let t = 31536000000 * 35
		let time1 = 1625068800000 // 2021年7月1日
		let time2 = 1666454400000 // 2022年10月23日
		if (regTime >= time1 && regTime <= time2) {
			result = nowTime - t <= birthday ? true : false
		}
		return result
	},

	// 校验身份证是否正确
	checkIdCard(val) {
		const lastList = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
		const list = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
		let cardIdList = val.split('')
		let num = 0
		for (let i = 0; i < list.length; i++) {
			num += cardIdList[i] * list[i]
		}
		let num2 = num % 11
		let result = lastList[num2]
		if (result === cardIdList[17] && !Number.isNaN(num) && !Number.isNaN(num2)) {
			return true
		} else {
			return false
		}
	},

	IdCard(IdCard, type) {
		if (!this.checkIdCard(IdCard)) {
			console.log('false')
			return
		}
		if (type === 1) {
			//获取出生日期
			let birthday =
				IdCard.substring(6, 10) +
				'-' +
				IdCard.substring(10, 12) +
				'-' +
				IdCard.substring(12, 14)
			return birthday
		}
		if (type === 2) {
			//获取性别
			if (parseInt(IdCard.substr(16, 1)) % 2 === 1) {
				return '男'
			} else {
				return '女'
			}
		}
		if (type === 3) {
			//获取年龄
			var ageDate = new Date()
			var month = ageDate.getMonth() + 1
			var day = ageDate.getDate()
			var age = ageDate.getFullYear() - IdCard.substring(6, 10) - 1
			if (
				IdCard.substring(10, 12) < month ||
				(IdCard.substring(10, 12) === month && IdCard.substring(12, 14) <= day)
			) {
				age++
			}
			if (age <= 0) {
				age = 1
			}
			return age
		}
	},
	goPath(id) {
		if (id === 0) {
			router.push({
				name: 'Home'
			})
		}
		else if (id === 1) {
			this.IndexValue = '0'
		}

	},
}
